import React from "react";
import MerchantLayout from "../../layout/MerchantLayout";
import { Button, Form, Input, Radio, Space, Typography, Upload } from "antd";
import { useState } from "react";
import axios from "axios";
import GcashDesign from "../../welcome/pricing/gcash-design";
import CardDesign from "../../welcome/pricing/card-design";
import { NotificationInfo, SubscriptionInfo, UserInfo } from "../../../context";
import { useContext } from "react";
import moment from "moment";

const RenewSubscription = () => {
  const [value, setValue] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [fileList, setFileList] = useState([{}]);
  const [loadings, setLoadings] = useState(false);
  var subscriptionmessage =
    "Thank you for subscribing again to our plan. We look forward to communicating more with you. If you have any concern or question with your subscription, you can just email us here: administrator@nehemiahsolutions.com.";
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);

  const onChangePaymentMethod = (e) => {
    setSelectedPaymentMethod(e.target.value);
    // console.log("E", e.target.value);
  };

  const onChange = (e) => {
    setValue(e.target.value);
    var finalTotal = 0;
    if (e.target.value === "12 months") {
      var total = 12 * 2500;
      finalTotal = total;
    } else {
      finalTotal = 6 * 2500;
    }
    setTotalValue(parseFloat(finalTotal));
  };

  const handleChange = (info) => {
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    setFileList(fileList);
  };

  const handleRenewMerchant = (values) => {
    const formdata = new FormData();
    formdata.append("amount", totalValue);
    formdata.append("plan", subscriptionDetails.data.current_plan);
    formdata.append("message", subscriptionmessage);
    formdata.append("image", values.file === undefined ? "" : values.file.file);
    formdata.append("email", userData.data.email);
    formdata.append("user_id", userData.data.id);

    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);

    axios
      .post("/renew-subscription", formdata)
      .then((response) => {
        const data = response.data;
        if (data.success === true) {
          rerunNotif("success", data.message);
          setTimeout(() => {
            navigate(-1);
            setLoadings(false);
          }, 1000);
        } else {
          rerunNotif("error", data.message);
          setTimeout(() => {
            setLoadings(false);
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
        console.log("Error: ", error);
      });
  };

  return (
    <MerchantLayout>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: 1200,
          width: "100%",
          minHeight: "calc(100vh - 128px)",
          padding: 10,
          backgroundColor: "#e5e5e5",
          // border: "1px solid red",
        }}
      >
        <Form
          layout="vertical"
          name="create-merchant-from-subscription"
          // initialValues={{
          //   business_name: data.business_name,
          //   business_province: data.business_province,
          //   business_city: data.business_city,
          //   business_barangay: data.business_barangay,
          //   business_street: data.business_street,
          // }}
          onFinish={handleRenewMerchant}
          autoComplete="off"
          style={{
            border: "1px solid #aeaeae",
            margin: 0,
            width: "100%",
            maxWidth: 320,
            padding: 15,
            borderRadius: 10,
            boxShadow: "1px 2px 9px #AEAEAE",
            backgroundColor: "#fff",
          }}
        >
          <div
            style={{
              // display: plan === "trial" ? "none" : "flex",
              display: "flex",
              justifyContent: "center",
              // border: "1px solid red",
              width: "100%",
            }}
          >
            {/* <div style={{ flexGrow: 1 }}>
              <Typography
                style={{
                  textTransform: "capitalize",
                  fontSize: 20,
                  marginBottom: 10,
                  fontWeight: "bold",
                }}
              >
                Plan: {plan}
              </Typography>
            </div> */}
            <div>
              <Typography
                style={{
                  textTransform: "capitalize",
                  fontSize: 20,
                  marginBottom: 10,
                  fontWeight: "bold",
                }}
              >
                &#8369;{" "}
                {parseFloat(totalValue).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
            </div>
          </div>

          <div style={{ width: "100%" }}>
            {selectedPaymentMethod === "gcash" ? (
              <GcashDesign />
            ) : selectedPaymentMethod === "bank" ? (
              <CardDesign />
            ) : (
              ""
            )}
          </div>

          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="payment_method"
              label="Payment_method"
              rules={[
                {
                  // required: plan === "trial" ? false : true,
                  required: true,
                  message: "Payment method required!",
                },
              ]}
              // style={{ display: plan === "trial" ? "none" : "block" }}
              style={{ display: "block" }}
            >
              <Radio.Group onChange={onChangePaymentMethod} value={value}>
                <Space direction="vertical">
                  <Radio value={"gcash"}>Gcash</Radio>
                  <Radio value={"bank"}>Bank</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              name="plan_duration"
              label="Plan Duration"
              rules={[
                {
                  // required: plan === "trial" ? false : true,
                  required: true,
                  message: "Plan duration required!",
                },
              ]}
              // style={{ display: plan === "trial" ? "none" : "block" }}
              style={{ display: "block" }}
            >
              <Radio.Group onChange={onChange} value={value}>
                <Space direction="vertical">
                  {/* <Radio value={"12 months"}>12 Months (5% Discount)</Radio> */}
                  <Radio value={"12 months"}>12 Months</Radio>
                  <Radio value={"6 months"}>6 Months</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              name="file"
              label="Payment Attachment"
              rules={[
                {
                  // required: plan === "trial" ? false : true,
                  required: true,
                  message: "Payment screenshot required!",
                },
              ]}
              // style={{ display: plan === "trial" ? "none" : "block" }}
              style={{ display: "block" }}
            >
              <Upload
                beforeUpload={({ fileList: newFileList }) => {
                  return false;
                }}
                onChange={handleChange}
                multiple={false}
                listType="picture-card"
                maxCount={1}
                showUploadList={{
                  showRemoveIcon: false,
                }}
                fileList={fileList}
              >
                Upload
              </Upload>
            </Form.Item>

            <Form.Item style={{}}>
              <Button
                type="primary"
                loading={loadings}
                htmlType="submit"
                style={{ width: "100%", borderRadius: "20px" }}
                size="large"
              >
                {loadings ? "Loading" : "Renew"}
              </Button>
            </Form.Item>
          </Space>
        </Form>
      </div>
    </MerchantLayout>
  );
};

export default RenewSubscription;
